const intl = window.intl;

export const getPageTitle = (pageIntlID) => {
  const pageTitle = intl.formatMessage({ id: pageIntlID });
  const siteTitle = intl.formatMessage({ id: "title" });
  return `${pageTitle} | ${siteTitle}`
};
